import { Injectable } from '@angular/core';
import { BaseNotifier } from '../../../../shared/notifiers/base-notifier';
import { Ref } from '../../../../shared/providers/ref';
import { MapProvider } from '../map/map-provider';
import { MagneticNorthState } from './magnetic-north-state';
import MapView from '@arcgis/core/views/MapView';

@Injectable()
export class MagneticNorthNotifier extends BaseNotifier<MagneticNorthState> {
  private intervalHandle: ReturnType<typeof setInterval> | null = null;

  constructor(ref: Ref) {
    super(ref, { rotation: 0 });
  }

  override build(): void {
    const tryStart = () => {
      const v = this.ref.watch(MapProvider).state().view;
      if (!v) return false;
      const tick = () => {
        const r = (v as MapView).rotation ?? 0;
        if (r !== this.snapshot().rotation) {
          this.setState({ rotation: r });
        }
      };
      tick();
      this.intervalHandle = setInterval(tick, 150);
      return true;
    };
    if (!tryStart()) {
      const iv = setInterval(() => {
        if (tryStart()) clearInterval(iv);
      }, 500);
    }
  }

  override onDispose(): void {
    if (this.intervalHandle) {
      clearInterval(this.intervalHandle);
      this.intervalHandle = null;
    }
  }

  resetNorth(): void {
    const view = this.ref.watch(MapProvider).state().view;
    if (!view) return;
    const cur = (view as MapView).rotation ?? 0;
    if (Math.abs(cur) < 0.5) return;
    view.goTo({ rotation: 0, center: view.center ?? undefined, zoom: view.zoom ?? undefined } as any, { duration: 500 });
  }
}
